/**
 * Overlay switches.
 *
 * Required by the spec, and for a good reason: with EMA, Bollinger, zones,
 * Fibonacci and the signal levels all drawn at once the chart is unreadable.
 */

import { useAppStore, type OverlayToggle } from '@/store/useAppStore'

const TOGGLES: { key: OverlayToggle; label: string; hint: string }[] = [
  { key: 'showEma', label: 'EMA', hint: 'EMA 20 / 50 / 200' },
  { key: 'showBollinger', label: 'BB', hint: 'Bollinger Bands (20, 2)' },
  { key: 'showZones', label: 'S/R', hint: 'Vùng hỗ trợ / kháng cự theo số lần chạm' },
  { key: 'showFib', label: 'Fib', hint: 'Fibonacci thoái lui của sóng đẩy gần nhất' },
  { key: 'showSignalLines', label: 'Entry/SL/TP', hint: 'Marker mua-bán và các mức giá của tín hiệu' },
  { key: 'showVolume', label: 'Volume', hint: 'Khối lượng ở pane riêng (nguồn forex không có volume)' },
]

export function OverlayToggles() {
  const state = useAppStore()

  return (
    <div className="flex flex-wrap items-center gap-1 border-b border-border px-3 py-1.5">
      <span className="mr-1 text-2xs text-ink-dim">Lớp vẽ:</span>
      {TOGGLES.map(({ key, label, hint }) => {
        const active = state[key]
        return (
          <button
            key={key}
            title={hint}
            onClick={() => state.toggle(key)}
            className={`rounded border px-2 py-0.5 text-2xs transition-colors ${
              active
                ? 'border-accent/60 bg-accent/15 text-ink'
                : 'border-border bg-panel-alt text-ink-dim hover:text-ink'
            }`}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
